import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {ApiService} from './api.service';


@Injectable()
export class PlansService {


  constructor(
    private apiService: ApiService
  ) {
  }

  getAll(query = '') {
    return this.apiService.get(
      `/plans${query}`
    );
  }

  get(id) {
    return this.apiService.get(`/plans/${id}`);
  }

  getCustomers(id, page) {
    return this.apiService.get(`/plans/${id}/customers${page}`);
  }

  search(keyword) {
    return this.apiService.post(`/plans/search`, {
      keyword
    })
      .pipe(
        map(
          (result: any) => result.data
        )
      );
  }

  searchCustomer(id, keyword) {
    return this.apiService.post(`/plans/${id}/customers/search`, {
      keyword
    });
  }

  create(plan: Plan) {
    return this.apiService.post(`/plans`, plan);
  }

  update(id, plan: Plan) {
    return this.apiService.put(`/plans/${id}`, plan);
  }

  destroy(id) {
    return this.apiService.delete(`/plans/${id}`);
  }

  getPlanStatics(id) {
    return this.apiService.get(`/statistics/plan/${id}`);
  }

}
